export const isNotFound = (ex: unknown) => {
  if (!ex || typeof ex !== 'object') return false;
  if (!('status' in ex)) return false;

  return ex.status === 404;
};
